// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1pAAB","options":"AnswerScale_options__3VzJ8","selected":"AnswerScale_selected__1Ie4k"};